import { z } from "zod";

export const courtBranchSchema = z.object({
	id: z.string(),
	court_station_id: z.string(),
	name: z.string(),
	judge: z.string(),
	status: z.string(),
	address: z.string(),
	assignable: z
		.object({
			id: z.string(),
			type: z.string(),
		})
		.optional(),
	created_at: z.string(),
});

export const courtBranchFormSchema = z.object({
	id: z.string().optional(),
	court_station_id: z.string(),
	name: z.string(),
	judge: z.string(),
	assignable: z
		.object({
			id: z.string(),
			type: z.string(),
		})
		.optional(),
	address: z.string(),
});

export type CourtBranch = z.infer<typeof courtBranchSchema>;
export type CourtBranchForm = z.infer<typeof courtBranchFormSchema>;
